module.exports = __webpack_public_path__ + "static/Rob-bc445b3f930e2cbccb94a7ae1fe665b9.png";